import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../../../../../../core/components/modals/base-modal/base-modal.component";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {FormsModule} from "@angular/forms";
import {MatInput} from "@angular/material/input";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {EditPlanDialogData, PlanFactException} from "../../../types/release-calendar-types";
import {MatButton, MatFabButton} from "@angular/material/button";
import {PlanFactExceptionService} from "../../../services/plan-fact-exception.service";
import {MatIconModule} from "@angular/material/icon";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-release-calendar-edit-plan-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    MatFormField,
    FormsModule,
    MatInput,
    MatLabel,
    MatButton,
    MatIconModule,
    MatFabButton,
    CommonModule
  ],
  templateUrl: './release-calendar-edit-plan-modal.component.html',
  styleUrl: './release-calendar-edit-plan-modal.component.scss'
})
export class ReleaseCalendarEditPlanModalComponent extends BaseModalComponent {
  private dialogData = inject<EditPlanDialogData>(MAT_DIALOG_DATA);
  private planFactExceptionService: PlanFactExceptionService = inject(PlanFactExceptionService);

  public limit: number = 0;
  public planFactExceptionId: number = 0;

  public override ngOnInit() {
    super.ngOnInit();
    this.limit = this.dialogData.planFactException.dayLimit;
    this.planFactExceptionId = this.dialogData.planFactException.id;
  }

  public handleInputEvent(event: Event): void {
    const value = this.validationService.allowPaste(event);
    if (value === null) {
      this.limit = this.dialogData.planFactException.dayLimit;
      return;
    }

    this.limit = +value;
  }

  public getBtnText(): string {
    return this.planFactExceptionId ? 'Обновить' : 'Создать';
  }

  public async handleClick(): Promise<void> {
    if (!this.limit) {
      this.errorService.showErrorMessage('Лимит не может быть равен 0');
      return;
    }

    const planFactException = this.getPlanFactException();
    if (planFactException.dayLimit < this.dialogData.plannedDayPrice) {
      this.errorService.showErrorMessage('Лимит не может быть меньше дневного лимита');
      return;
    }

    this.planFactExceptionId ?
      await this.updatePlanFactException(planFactException) :
      await this.createPlanFactException(planFactException);
  }

  public async handleDeleteClick(): Promise<void> {
    await this.planFactExceptionService.deletePlanFactExceptions(this.planFactExceptionId)
      .then(() => this.dialogRef.close({planFactException: this.getPlanFactException(), action: 'delete'}))
      .catch(() => this.closeDialog('cancel'));
  }

  private getPlanFactException(): PlanFactException {
    return {
      id: this.planFactExceptionId,
      date: this.dialogData.planFactException.date,
      productId: this.dialogData.planFactException.productId,
      dayLimit: this.limit
    };
  }

  private async createPlanFactException(planFactException: PlanFactException): Promise<void> {
    await this.planFactExceptionService.createPlanFactExceptions(planFactException)
      .then((planFactException) => this.dialogRef.close({planFactException: planFactException, action: 'create'}))
      .catch(() => this.closeDialog('cancel'));
  }

  private async updatePlanFactException(planFactException: PlanFactException): Promise<void> {
    await this.planFactExceptionService.updatePlanFactExceptions(planFactException)
      .then((planFactException) => this.dialogRef.close({planFactException: planFactException, action: 'update'}))
      .catch(() => this.closeDialog('cancel'));
  }
}
